import { Paper, Box, Typography, Badge, Grid, ThemeProvider, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import * as React from 'react';
import { useEffect } from 'react';
import SimpleCollapse from '../../../component/MuiReusableComponents/MuiCollapse/collapseMUI';
import { useDispatch, useSelector } from 'react-redux';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import AdminTableSortingAndSelect from 'component/LeavesTable/AdminTableSortingAndSelect';
import SearchIcon from '@mui/icons-material/Search';
import { useForm, FormProvider } from 'react-hook-form';
import {
    allLeavesDataSelector,
    leaveEmployeeDropdownData,
    fetchEmployeeLeaveData,
    startAllLeavesData,
    isLoadingSelectorLeave
} from '../../../store1/leaves data/leavesData.Slice.Selector';
import { allClientsDataSelector } from '../../../store1/client data/client.data.slice.selector';
import MyButton from '../../../component/MuiReusableComponents/MuiButton/buttonMUI';
import MySelect from '../../../component/MuiReusableComponents/MuiFormComponents/Select.component';
import MaterialUIPickers from '../../../component/MuiReusableComponents/MuiFormComponents/DatePicker/date.picker.component';
import FormHead from '../../../component/MuiReusableComponents/FormHeadText/formHeadText';
import { approvalStatus } from '../../../function utils/functionUtils';
import BackdropComp from '../../../component/MuiReusableComponents/backdrop/backdrop';
import { PERMISSIONS } from 'routes/permissionsCode';
import { hasPermission, usersDataSelector } from 'store1/user login data/user.login.data.slice.slector';

const FilterAndSearchBox = ({ infoData }) => {
    const { setCollapseFilterControl, setFilteredRows, rows, setFilterStatus, filterStatus } = infoData;

    const dispatch = useDispatch();
    const employeeDropdown = useSelector(leaveEmployeeDropdownData);
    const employeeDropdownArray = employeeDropdown?.map((item) => ({
        name: item.employee_name,
        value: item.employee_id
    }));

    React.useEffect(() => {
        dispatch(fetchEmployeeLeaveData());
    }, []);

    React.useEffect(() => {
        if (!filterStatus) {
            form.reset({
                startDateValue: null,
                endDateValue: null,
                employee_name: '',
                approval_status: 'all'
            });
        }
    }, [filterStatus]);

    const arrayApprovalStatus = [
        {
            name: 'All',
            value: 'all'
        },
        ...approvalStatus
    ];

    const form = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: {
            startDateValue: null,
            endDateValue: null,
            employee_name: '',
            approval_status: 'all'
        }
    });

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const onSubmit = (data) => {
        const payload = {
            pageSize: 10,
            pageIndex: 1,
            empId: data.employee_name ? data.employee_name : '-1',
            approval_status: data.approval_status && data.approval_status !== 'all' ? data.approval_status : '-1',
            start_date: data.startDateValue ? formatDate(data.startDateValue) : '',
            end_date: data.endDateValue ? formatDate(data.endDateValue) : ''
        };

        dispatch(startAllLeavesData(payload));
        setFilterStatus(true);
    };

    const handleReset = () => {
        setFilterStatus(false);

        dispatch(
            startAllLeavesData({
                pageSize: 10,
                pageIndex: 1,
                empId: '-1',
                start_date: '',
                end_date: '',
                approval_status: '-1'
            })
        );

        form.reset({
            startDateValue: null,
            endDateValue: null,
            employee_name: '',
            approval_status: 'all'
        });
    };

    return (
        <Paper sx={{ borderRadius: '10px', marginBottom: '15px', bgcolor: '#dff9fb87' }}>
            <Box
                sx={{
                    textAlign: 'right',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: '10px',
                    bgcolor: '#ffeaa786'
                }}
            >
                <Typography
                    sx={{
                        width: '100%',
                        textAlign: 'left',
                        fontWeight: 'bold',
                        paddingLeft: '25px'
                    }}
                    variant="subtitle1"
                    gutterBottom
                >
                    Filter
                </Typography>
            </Box>
            <FormProvider {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    <Grid container columnSpacing={1} sx={{ padding: '10px 20px 0px 20px' }}>
                        <Grid item xs={12} sm={2}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: '0px 15px'
                                }}
                            >
                                <FormHead headText="Name " />
                                <MySelect
                                    fullWidth
                                    label="Select Employee"
                                    size="small"
                                    name="employee_name"
                                    style={{ width: '100%' }}
                                    items={employeeDropdownArray}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: '0px 15px'
                                }}
                            >
                                <FormHead headText="Status " />
                                <MySelect
                                    fullWidth
                                    size="small"
                                    name="approval_status"
                                    style={{ width: '100%' }}
                                    items={[...arrayApprovalStatus]}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={5}>
                            <Grid container rowSpacing={1} columnSpacing={1}>
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <FormHead headText="Date Range" />
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <MaterialUIPickers
                                                label="Start Date"
                                                size="small"
                                                views={['year', 'month', 'day']}
                                                name="startDateValue"
                                                sx={{ width: '100%' }}
                                            />
                                            <Typography variant="body1" sx={{ margin: '0 10px' }}>
                                                to
                                            </Typography>
                                            <MaterialUIPickers
                                                label="End Date"
                                                size="small"
                                                views={['year', 'month', 'day']}
                                                name="endDateValue"
                                                sx={{ width: '100%' }}
                                            />
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    width: '100%',
                                    textAlign: 'center',
                                    paddingBottom: '10px'
                                }}
                            >
                                <MyButton
                                    size="small"
                                    title="Search"
                                    sx={{ marginRight: '15px' }}
                                    variant="contained"
                                    type="submit"
                                    startIcon={<SearchIcon />}
                                >
                                    Search
                                </MyButton>
                                <MyButton
                                    sx={{ marginRight: '15px' }}
                                    title="Reset"
                                    onClick={handleReset}
                                    size="small"
                                    color="error"
                                    variant="contained"
                                >
                                    Reset
                                </MyButton>
                                <MyButton
                                    variant="outlined"
                                    title="Close"
                                    size="small"
                                    onClick={() => {
                                        setCollapseFilterControl(false);
                                    }}
                                    startIcon={<CancelPresentationIcon color="error" />}
                                >
                                    Close
                                </MyButton>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </FormProvider>
        </Paper>
    );
};

// Main Component for Admin
const AdminLeavesData = () => {
    const hasAdminPermission = useSelector((state) => hasPermission(state, PERMISSIONS.HR.LEAVE.ADMIN_APPLY));
    const dispatch = useDispatch();
    const loginData = useSelector(usersDataSelector);
    const theme = useTheme();
    const leaveData = useSelector(allLeavesDataSelector);
    const clientData = useSelector(allClientsDataSelector);
    const [collapseFilterControl, setCollapseFilterControl] = React.useState(false);
    const [filterStatus, setFilterStatus] = React.useState(false);
    const [filteredRows, setFilteredRows] = React.useState([]);
    const clientsNameArray = clientData.map((item) => item.name);
    const isLoadingLeave = useSelector(isLoadingSelectorLeave);
    const location = useLocation();
    const navigate = useNavigate();
    const search = new URLSearchParams(location.search);
    const currentPageIndex = Number(search.get('pageIndex')) || 1;
    const PAGE_SIZE = 10;

    React.useEffect(() => {
        setFilteredRows(leaveData);
    }, [leaveData]);

    const headCells = [
        {
            id: 'id',
            label: 'S.No',
            numeric: false,
            disablePadding: false
        },
        {
            id: 'employee_name',
            numeric: false,
            disablePadding: false,
            label: 'Name'
        },
        {
            id: 'leave_type_name',
            numeric: false,
            disablePadding: false,
            label: 'Leave Type'
        },
        {
            id: 'from_date',
            numeric: false,
            disablePadding: false,
            label: 'From Date'
        },
        {
            id: 'to_date',
            numeric: false,
            disablePadding: false,
            label: 'To Date'
        },
        {
            id: 'duration',
            numeric: false,
            disablePadding: false,
            label: 'Duration'
        },
        {
            id: 'approval_status',
            numeric: false,
            disablePadding: false,
            label: 'Status'
        },
        // {
        //   id: "update_status",
        //   numeric: false,
        //   disablePadding: false,
        //   label: "Update Status",
        // },
        {
            id: 'action',
            numeric: false,
            disablePadding: false,
            label: 'view'
        }
    ];

    useEffect(() => {
        dispatch(
            startAllLeavesData({
                pageSize: PAGE_SIZE,
                pageIndex: currentPageIndex,
                empId: '-1',
                start_date: '',
                end_date: '',
                approval_status: '-1'
            })
        );
    }, [dispatch, currentPageIndex]);

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    width: {
                        xs: '96%',
                        sm: '100%'
                    },
                    p: '1px'
                }}
            >
                <BackdropComp isLoading={isLoadingLeave} />

                {hasAdminPermission && (
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            justifyContent: 'end',
                            marginBottom: '20px'
                        }}
                    >
                        <Box sx={{ display: 'flex' }}>
                            <Box sx={{ marginRight: '15px' }}>
                                <Badge color="secondary" variant={filterStatus ? 'dot' : 'standard'}>
                                    <MyButton
                                        size="small"
                                        title="Filter"
                                        startIcon={<FilterAltIcon />}
                                        variant="contained"
                                        onClick={() => setCollapseFilterControl(!collapseFilterControl)}
                                    >
                                        Filter
                                    </MyButton>
                                </Badge>
                            </Box>

                            <Box sx={{ marginRight: '15px' }}>
                                <MyButton
                                    title="Apply Leave"
                                    size="small"
                                    variant="contained"
                                    onClick={() => navigate('/employee-management/leave-management/employee-leaves/apply-leave')}
                                >
                                    {' '}
                                    + Apply Leave
                                </MyButton>
                            </Box>
                        </Box>
                    </Box>
                )}

                <SimpleCollapse
                    infoData={{
                        setCollapseFilterControl,
                        clientsNameArray,
                        setFilteredRows,
                        setFilterStatus,
                        filterStatus,
                        rows: leaveData
                    }}
                    control={collapseFilterControl}
                    CollapseComponent={FilterAndSearchBox}
                />
                <Box>
                    <AdminTableSortingAndSelect headCells={headCells} rows={filteredRows} currentPageIndex={currentPageIndex} />
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default AdminLeavesData;
